<template>
  <div id="app">
    <head>
      <link href="favicon.ico" rel="shortcut icon" />
    </head>
    <router-view></router-view>
  </div>
</template>
<style>
@import "./assets/css/main.css";
/* @import "./assets/css/color-dark.css";     深色主题 */
/*@import "./assets/css/theme-green/color-green.css";   浅绿色主题*/
</style>
<script>
export default {
  name: "app",
  data() {
    return {};
  },
  computed: {},
  methods: {
    //app.vue
    localSocket() {
      let that = this;
      if ("WebSocket" in window) {
        // console.log("您的浏览器支持 WebSocket!");
        // location.host
        that.ws = new WebSocket("wss://gps.trackline.cn:1028");
        that.global.setWs(that.ws);
        that.ws.onopen = function (res) {
          console.log(res);
          console.log("websocket连接成功");
        };
        console.log(that.global.ws);
        console.log(that.global.ws.readyState);
        that.ws.onclose = function (res) {
          console.log("连接已关闭...");
          //断线重新连接
          setTimeout(() => {
            that.localSocket();
          }, 1000);
        };
      } else {
        // 浏览器不支持 WebSocket
        console.log("您的浏览器不支持 WebSocket!");
        this.openNotificationWithIcon(
          "error",
          "浏览器",
          "您的浏览器不支持显示消息请更换",
          1,
          1
        );
      }
    },
  },

  created() {
    // let _this =this;
    //   setTimeout(function(){
    //     console.log(_this.$route.path);
    //   },100)
  },
  mounted() {
    this.localSocket();
    //自动加载indexs方法
    // this.$router.push("/options");
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue